import React, { useState, useEffect } from 'react';
import { signOutUser, signInWithGoogle } from '../firebaseClient';
import './Header.css';

export default function Header({ uploadStatus, onHome, user, lastSaved, isSaving, saveFailed }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!lastSaved) return;
    const interval = setInterval(() => setTick(t => t + 1), 10000);
    return () => clearInterval(interval);
  }, [lastSaved]);

  const statusLabel = {
    parsing: '⏳ Parsing PDF…',
    done: '✅ Resume imported!',
    error: '❌ Could not parse PDF',
  };

  const saveLabel = () => {
    if (!user) return null;
    if (saveFailed) return '⚠ Save failed — retrying…';
    if (isSaving) return '↑ Saving…';
    if (!lastSaved) return null;
    const secs = Math.floor((Date.now() - lastSaved.getTime()) / 1000);
    if (secs < 10) return '✓ Saved';
    if (secs < 60) return `✓ Saved ${secs}s ago`;
    return `✓ Saved ${Math.floor(secs / 60)}m ago`;
  };
  const label = saveLabel();

  return (
    <>
      <header className="header">
        <div className="header-brand" onClick={onHome} style={{ cursor: 'pointer' }} title="Back to home">
          <img src={`${process.env.PUBLIC_URL}/logos/logo.png`} alt="Cedar Resumes" style={{ width: 105, height: 105, objectFit: 'contain' }} />
          <div className="header-text">
            <span className="header-title">Cedar Resumes</span>
            <span className="header-tagline">Build it. Love it. Send it.</span>
          </div>
        </div>
        <div className="header-actions">
          {uploadStatus && (
            <span className={`upload-status status-${uploadStatus}`}>
              {statusLabel[uploadStatus]}
            </span>
          )}
          {label && (
            <span className={`header-save-status ${saveFailed ? 'failed' : isSaving ? 'saving' : 'saved'}`}>
              {label}
            </span>
          )}
          {user ? (
            <div className="header-user">
              <div className="header-avatar-initials">
                {(user.displayName || user.email || '?')
                  .split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()}
              </div>
              <span className="header-user-name">
                {user.displayName || user.email}
              </span>
              <button className="btn-sign-out" onClick={signOutUser}>Sign out</button>
            </div>
          ) : (
            <div className="header-signin-prompt">
              <span className="header-signin-text">Sign in to save your work</span>
              <button className="btn-sign-in" onClick={async () => {
                try { await signInWithGoogle(); }
                catch (e) { if (e.code !== 'auth/cancelled-popup-request' && e.code !== 'auth/popup-closed-by-user') console.error(e); }
              }}>
                <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                </svg>
                Sign in with Google
              </button>
            </div>
          )}
        </div>
      </header>
    </>
  );
}
